import { SearchInput } from '@lokalise/louis';
import { createRef } from 'react';

import useEffectOnce from '@app/hooks/useEffectOnce';

import { BranchSearchInputContainer } from './styles';

type BranchSearchInputProps = {
    onValueChange: (value: string) => void;
};

const BranchSearchInput = ({ onValueChange }: BranchSearchInputProps) => {
    const inputRef = createRef<HTMLInputElement>();

    useEffectOnce(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }

        onValueChange(inputRef.current ? inputRef.current.value : '');
    });

    return (
        <BranchSearchInputContainer>
            <SearchInput
                debounceTime={0}
                inputSize="small"
                onValueChange={onValueChange}
                placeholder="Search"
                ref={inputRef}
            />
        </BranchSearchInputContainer>
    );
};

export default BranchSearchInput;
